import { render, staticRenderFns } from "./openClassInformationTeacher.vue?vue&type=template&id=d80d656c&scoped=true"
import script from "./openClassInformationTeacher.vue?vue&type=script&lang=js"
export * from "./openClassInformationTeacher.vue?vue&type=script&lang=js"
import style0 from "./openClassInformationTeacher.vue?vue&type=style&index=0&id=d80d656c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d80d656c",
  null
  
)

export default component.exports